// @flow
import { MICROACTIONS_PATH } from 'app/constants/navLinks'

export const ORG_INACTIVE_NOTIFICATIONS_ENDPOINT = id =>
  `${MICROACTIONS_PATH}/organizations/${id}/inactive-notifications`
